import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/auth/api";

// Fetch Panel User Data
export const fetchProjectSectionField = createAsyncThunk(
  "accesprojectSectionField/fetchProjectSectionField",
  async ({ page = 1, search = "", fetchAll = false }, { rejectWithValue, getState }) => {
    try {
      const { accesprojectSectionField } = getState();
      const { pageSize , cache} = accesprojectSectionField;

        const cacheKey = `${page}_${search}_${pageSize}_${fetchAll}`;

      // ✅ cache check
      if (cache[cacheKey]) {
        return {
          data: cache[cacheKey],
          page,
          search,
          pageSize,
          fromCache: true,
        };
      }

      let url = `/access/panel/Section/Field`;

      if (!fetchAll) {
        url += `?page=${page}&page_size=${pageSize}`;
      } else {
        url += `?page=1&page_size=10000`; // huge number to get all users
      }

      if (search) {
        url += `&search=${search}`;
      }

      const response = await api.get(url);
      return {
        data: response?.data,
        page,
        search,
        pageSize,
        fromCache: false,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


// Panel User Slice
const AcessprojectSectionFieldSlice = createSlice({
  name: "accesprojectSectionField",
  initialState: {
    accessProjectSectionFieldList: { result: [], pagination: { total_pages: 1 } },
    search: "", // ✅ NEW
    currentPage: 1,
    pageSize: 10, // ✅ controlled here
    totalPages: 1,
    cache: {}, // store data per page
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
     setPage: (state, action) => {
      state.currentPage = action.payload;
    },

      setPageSize: (state, action) => { 
      state.pageSize = action.payload;
      state.currentPage = 1; 
      state.cache = {}; 
    },
  
    // ✅ ADD THIS
  clearCache: (state) => {
    state.cache = {};
  }

  },
  extraReducers: (builder) => {
    builder
      // Fetch Panel User Data
      .addCase(fetchProjectSectionField.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(fetchProjectSectionField.fulfilled, (state, action) => {
        const { data, page, search, pageSize, fromCache } = action.payload;
        const cacheKey = `${page}_${search}_${pageSize}_${false}`;
        // ✅ Save in cache if not cached already
        if (!fromCache) {
          state.cache[cacheKey] = data;
        }
        state.accessProjectSectionFieldList = data;
         // ✅ Page handling
         state.currentPage = page;
      // ✅ IMPORTANT: Calculate total pages from count
        const totalCount = data?.pagination?.count || 0;
        state.totalPages = Math.ceil(totalCount / pageSize);
        state.search = search;
        state.pageSize = pageSize;
        state.status = "succeeded";
      })
      .addCase(fetchProjectSectionField.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

 },
});

export const { clearError ,  setPage, setPageSize , clearCache} = AcessprojectSectionFieldSlice.actions;

export default AcessprojectSectionFieldSlice.reducer;
